import type { LanguageKey } from "@/shared/common/enums";
import { createAsyncThunk } from "@reduxjs/toolkit";
import type { RootState } from "app/store";
import i18n from "i18next";

import { setChangingLanguage, setLanguage } from "./languageSlice";

export const changeLanguage = createAsyncThunk<void, LanguageKey, { state: RootState }>(
  "language/changeLanguage",
  async (lang: LanguageKey, { dispatch }) => {
    dispatch(setChangingLanguage(true));
    i18n.changeLanguage(lang).then(() => {
      dispatch(setLanguage(lang));
      dispatch(setChangingLanguage(false));
      window.location.reload();
    });
  }
);
